import moment from "moment-jalaali";

export function calculateOrderTotals(data) {
  let total = 0;
  let fee_total = 0;
  let now = parseInt(Date.now() / 1000);
  let statuses = [];
  data?.suppliers.forEach((supplier) => {
    let sup_total = 0;
    let sup_feeTotal = 0;
    supplier.products.forEach((product) => {
      const productTotal = parseFloat(product.price) * parseInt(product.count);
      const feeProduct =
        parseFloat(product.product_fee) * parseInt(product.count);
      sup_total += productTotal;
      sup_feeTotal += parseInt(feeProduct);
    });
    supplier.total = sup_total;
    supplier.feeTotal = sup_feeTotal;
    total += sup_total;
    fee_total += sup_feeTotal;
    if (!statuses.includes(supplier.status)) statuses.push(supplier.status);
  });
  data.total = parseInt(total);
  data.totalFee = fee_total;
  if (statuses.length === 1) data.orderStatus = statuses[0];
  else if (
    statuses.includes("0") ||
    statuses.includes("1") ||
    statuses.includes("1.1") ||
    statuses.includes("2")
  )
    data.orderStatus = "*";
  else data.orderStatus = "-";

  if (data.orderStatus === "-3" && now - parseInt(data.date) > 3600)
    data.orderStatus = "-4";

  data.referral = 0;
  if (data.wallet_transactions.length > 0) {
    data.wallet_transactions.forEach((w) => {
      if (w.user_type === "user" && w.action === "0" && w.amount > 0)
        data.referral = parseInt(w.amount);
    });
  }

  return data;
}

export const orderStatus = {
  0: "در انتظار تایید فروشنده",
  1: "در حال اماده سازی و در انتظار تایید پیک",
  1.1: "قبول شده توسط پیک و در انتظار تحویل به پیک",
  2: "در حال ارسال",
  3: "تحویل داده شده",
  "-1": "لغو شده توسط مشتری",
  "-2": "لغو شده توسط فروشنده",
  "-3": "در انتظار پرداخت",
  "-4": "پرداخت نشده",
  "*": "در حال انجام",
  "-": "خاتمه یافته در وضعیت های متفاوت",
};

export const vehicleListModel = {
  motorcycle: "موتورسیکلت",
  suv: "اس یو وی",
  van: "ون",
  pickup: "پیک آپ",
};
export const orderStatusColor = {
  0: "#f5a111",
  1: "#f5a111",
  1.1: "#f5a111",
  2: "#f5a111",
  3: "#1dd114",
  "-1": "#f80909",
  "-2": "#f80909",
  "-3": "#f5a111",
  "-4": "#f80909",
  "*": "#0c7fc2",
  "-": "#f80909",
};
export const userTypeEnum = {
  user: "مشتری",
  deliver: "پیک",
  supplier: "تامین کننده",
};
export const convertDate = (date,time=true) => {
  if(time){
    return moment.unix(parseInt(date)).format("jYYYY/jM/jD----hh:mm:ss a");
  }
  return moment.unix(parseInt(date)).format("jYYYY/jM/jD");

};